import { useSelectState } from "@react-stately/select";
import { useProvider, useProviderProps } from "@react-spectrum/provider";
import { useMessageFormatter } from "@react-aria/i18n";
import { useFormProps } from "@react-spectrum/form";
import { Text } from "@react-spectrum/text";
import _react, { useCallback, useRef, useState } from "react";
import { ProgressCircle } from "@react-spectrum/progress";
import { PressResponder, useHover } from "@react-aria/interactions";
import { Popover, Tray } from "@react-spectrum/overlays";
import { mergeProps, useLayoutEffect, useResizeObserver } from "@react-aria/utils";
import { ListBoxBase, useListBoxLayout } from "@react-spectrum/listbox";
import { Label } from "@react-spectrum/label";
import { HiddenSelect, useSelect } from "@react-aria/select";
import { FocusScope } from "@react-aria/focus";
import { FieldButton } from "@react-spectrum/button";
import { DismissButton, useOverlayPosition } from "@react-aria/overlays";
import { classNames, dimensionValue, SlotProvider, useDOMRef, useIsMobileDevice, useStyleProps, useUnwrapDOMRef } from "@react-spectrum/utils";
import _spectrumIconsUiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import _spectrumIconsUiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import { Item, Section } from "@react-stately/collections";
export { Item, Section };
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {};
$c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/dropdown/vars.css
var $e42ce057c820181717dfe5b0c524aea7$exports = {};
$e42ce057c820181717dfe5b0c524aea7$exports = {
  "spectrum-Dropdown": "_spectrum-Dropdown_06fc4",
  "spectrum-Dropdown-chevron": "_spectrum-Dropdown-chevron_06fc4",
  "spectrum-Dropdown-trigger": "_spectrum-Dropdown-trigger_06fc4",
  "spectrum-Dropdown-label": "_spectrum-Dropdown-label_06fc4",
  "is-placeholder": "_is-placeholder_06fc4",
  "spectrum-Icon": "_spectrum-Icon_06fc4",
  "spectrum-Dropdown-invalidIcon": "_spectrum-Dropdown-invalidIcon_06fc4",
  "spectrum-Dropdown-progressCircle": "_spectrum-Dropdown-progressCircle_06fc4",
  "spectrum-Dropdown--quiet": "_spectrum-Dropdown--quiet_06fc4",
  "spectrum-Dropdown-popover--quiet": "_spectrum-Dropdown-popover--quiet_06fc4",
  "spectrum-Field": "_spectrum-Field_06fc4",
  "spectrum-Dropdown-fieldWrapper--quiet": "_spectrum-Dropdown-fieldWrapper--quiet_06fc4",
  "spectrum-Dropdown-fieldWrapper--positionSide": "_spectrum-Dropdown-fieldWrapper--positionSide_06fc4",
  "is-hovered": "_is-hovered_06fc4",
  "is-selected": "_is-selected_06fc4",
  "is-invalid": "_is-invalid_06fc4",
  "is-disabled": "_is-disabled_06fc4",
  "focus-ring": "_focus-ring_06fc4"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/ar-AE.json
var $a3e858ac3eb0082448a5cca700f230b$exports = {};
$a3e858ac3eb0082448a5cca700f230b$exports = JSON.parse("{\"loading\":\"جار التحميل...\",\"placeholder\":\"حدد خيارًا...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/bg-BG.json
var $bd483e2b8cb8bc05627e2458ef2fb$exports = {};
$bd483e2b8cb8bc05627e2458ef2fb$exports = JSON.parse("{\"loading\":\"Зареждане...\",\"placeholder\":\"Изберете опция\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/cs-CZ.json
var $d1d6465e70bc987b490cf476cf84555b$exports = {};
$d1d6465e70bc987b490cf476cf84555b$exports = JSON.parse("{\"loading\":\"Načítání...\",\"placeholder\":\"Vyberte vhodnou možnost...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/da-DK.json
var $e0bfe68a0fe6f19e4f3b9c30391f896c$exports = {};
$e0bfe68a0fe6f19e4f3b9c30391f896c$exports = JSON.parse("{\"loading\":\"Indlæser ...\",\"placeholder\":\"Vælg en mulighed ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/de-DE.json
var $a027d117edc628c2fc5966ae$exports = {};
$a027d117edc628c2fc5966ae$exports = JSON.parse("{\"loading\":\"Laden...\",\"placeholder\":\"Option auswählen...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/el-GR.json
var $cc161f583409be69b01e28508dd77a$exports = {};
$cc161f583409be69b01e28508dd77a$exports = JSON.parse("{\"loading\":\"Φόρτωση...\",\"placeholder\":\"Επιλέξτε…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/en-US.json
var $f608e8361fdcead7a70abcd7409ce6cc$exports = {};
$f608e8361fdcead7a70abcd7409ce6cc$exports = JSON.parse("{\"placeholder\":\"Select an option…\",\"loading\":\"Loading…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/es-ES.json
var $f2f56e258d3696bef5b17007fc701b9$exports = {};
$f2f56e258d3696bef5b17007fc701b9$exports = JSON.parse("{\"loading\":\"Cargando…\",\"placeholder\":\"Seleccione una opción…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/et-EE.json
var $e2bfe9c76c56fd5f8d2805e336a1$exports = {};
$e2bfe9c76c56fd5f8d2805e336a1$exports = JSON.parse("{\"loading\":\"Laadimine...\",\"placeholder\":\"Valige valikuline...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/fi-FI.json
var $a59ed165d492a4cfc8024843f5c9151$exports = {};
$a59ed165d492a4cfc8024843f5c9151$exports = JSON.parse("{\"loading\":\"Ladataan…\",\"placeholder\":\"Valitse vaihtoehto...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/fr-FR.json
var $bd47cf98b9f28400c322f37dd5562df$exports = {};
$bd47cf98b9f28400c322f37dd5562df$exports = JSON.parse("{\"loading\":\"Chargement...\",\"placeholder\":\"Sélectionnez une option...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/he-IL.json
var $e4de70d221539e4e4277542a4a0301f$exports = {};
$e4de70d221539e4e4277542a4a0301f$exports = JSON.parse("{\"loading\":\"טוען...\",\"placeholder\":\"בחר אפשרות...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/hr-HR.json
var $b03e62cc6a2e467142e7b3185ca84c8$exports = {};
$b03e62cc6a2e467142e7b3185ca84c8$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"placeholder\":\"Odaberite opciju\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/hu-HU.json
var $cb2a618b794667d84350b485a709361$exports = {};
$cb2a618b794667d84350b485a709361$exports = JSON.parse("{\"loading\":\"Betöltés folyamatban...\",\"placeholder\":\"Válasszon egy opciót...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/it-IT.json
var $c2ed14c6d8b44b2088c397685388e6b4$exports = {};
$c2ed14c6d8b44b2088c397685388e6b4$exports = JSON.parse("{\"loading\":\"Caricamento...\",\"placeholder\":\"Seleziona un’opzione...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/ja-JP.json
var $cc5c89e3d1db3a8c40a2b793a8e9dee$exports = {};
$cc5c89e3d1db3a8c40a2b793a8e9dee$exports = JSON.parse("{\"loading\":\"読み込み中...\",\"placeholder\":\"オプションを選択...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/ko-KR.json
var $d4c29534d6725a177a069f02e6035f29$exports = {};
$d4c29534d6725a177a069f02e6035f29$exports = JSON.parse("{\"loading\":\"로드 중\",\"placeholder\":\"선택 사항 선택\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/lt-LT.json
var $c5f6700b36bb7976a2ff96ce4ed4bb$exports = {};
$c5f6700b36bb7976a2ff96ce4ed4bb$exports = JSON.parse("{\"loading\":\"Įkeliama...\",\"placeholder\":\"Pasirinkite parinktį...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/lv-LV.json
var $b1c736ce89bd99b5ed3e691d69baa12$exports = {};
$b1c736ce89bd99b5ed3e691d69baa12$exports = JSON.parse("{\"loading\":\"Notiek ielāde...\",\"placeholder\":\"Atlasiet opciju...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/nb-NO.json
var $cb458a4f6c581e186f4c36775531c55$exports = {};
$cb458a4f6c581e186f4c36775531c55$exports = JSON.parse("{\"loading\":\"Laster inn ...\",\"placeholder\":\"Velg et alternativ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/nl-NL.json
var $b4d2b4a9d751516d13e0963808404e$exports = {};
$b4d2b4a9d751516d13e0963808404e$exports = JSON.parse("{\"loading\":\"Laden...\",\"placeholder\":\"Optie selecteren...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/pl-PL.json
var $bd296420f236ed913ddbbfab9a63cefc$exports = {};
$bd296420f236ed913ddbbfab9a63cefc$exports = JSON.parse("{\"loading\":\"Ładowanie...\",\"placeholder\":\"Wybierz opcję...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/pt-BR.json
var $d5150585674a5afe719a59ab93$exports = {};
$d5150585674a5afe719a59ab93$exports = JSON.parse("{\"loading\":\"Carregando...\",\"placeholder\":\"Selecione uma opção...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/ro-RO.json
var $b505cb7e3f75774b9c57bd2b92c2186a$exports = {};
$b505cb7e3f75774b9c57bd2b92c2186a$exports = JSON.parse("{\"loading\":\"Se încarcă...\",\"placeholder\":\"Selectați o opțiune\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/ru-RU.json
var $d47e22347a353aaaffcf$exports = {};
$d47e22347a353aaaffcf$exports = JSON.parse("{\"loading\":\"Загрузка...\",\"placeholder\":\"Выбрать параметр...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/sk-SK.json
var $fdfdff040cf7a6ae1bcf24d365623726$exports = {};
$fdfdff040cf7a6ae1bcf24d365623726$exports = JSON.parse("{\"loading\":\"Načítava sa...\",\"placeholder\":\"Vyberte možnosť...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/sl-SI.json
var $fc44719192dca1041b7fb1ce3088ea1c$exports = {};
$fc44719192dca1041b7fb1ce3088ea1c$exports = JSON.parse("{\"loading\":\"Nalaganje...\",\"placeholder\":\"Izberite možnost\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/sr-SP.json
var $fdc251bdcb72dd76164ea66f1$exports = {};
$fdc251bdcb72dd76164ea66f1$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"placeholder\":\"Izaberite opciju\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/sv-SE.json
var $ebc2a88fe55fcf7339a78a814c6db9c$exports = {};
$ebc2a88fe55fcf7339a78a814c6db9c$exports = JSON.parse("{\"loading\":\"Läser in...\",\"placeholder\":\"Välj ett alternativ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/tr-TR.json
var $c1d8730967e62b8d6f3035e704d24e$exports = {};
$c1d8730967e62b8d6f3035e704d24e$exports = JSON.parse("{\"loading\":\"Yükleniyor…\",\"placeholder\":\"Bir seçim yapın…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/uk-UA.json
var $eded96a62d721b42449a6beec6af$exports = {};
$eded96a62d721b42449a6beec6af$exports = JSON.parse("{\"loading\":\"Завантаження...\",\"placeholder\":\"Виберіть опцію...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/zh-CN.json
var $ca104e556a75831cb795a233826f2a0$exports = {};
$ca104e556a75831cb795a233826f2a0$exports = JSON.parse("{\"loading\":\"正在加载...\",\"placeholder\":\"选择一个选项\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/picker/intl/zh-TW.json
var $e39eeb8a609d42b7f028409252178c5$exports = {};
$e39eeb8a609d42b7f028409252178c5$exports = JSON.parse("{\"loading\":\"正在載入\",\"placeholder\":\"選取一個選項\"}");
// @ts-ignore
const $f01f0d1066865f7027d77d32f5de6fe$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($a3e858ac3eb0082448a5cca700f230b$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($bd483e2b8cb8bc05627e2458ef2fb$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($d1d6465e70bc987b490cf476cf84555b$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($e0bfe68a0fe6f19e4f3b9c30391f896c$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($a027d117edc628c2fc5966ae$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($cc161f583409be69b01e28508dd77a$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($f608e8361fdcead7a70abcd7409ce6cc$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($f2f56e258d3696bef5b17007fc701b9$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($e2bfe9c76c56fd5f8d2805e336a1$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($a59ed165d492a4cfc8024843f5c9151$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($bd47cf98b9f28400c322f37dd5562df$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($e4de70d221539e4e4277542a4a0301f$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($b03e62cc6a2e467142e7b3185ca84c8$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($cb2a618b794667d84350b485a709361$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($c2ed14c6d8b44b2088c397685388e6b4$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($cc5c89e3d1db3a8c40a2b793a8e9dee$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($d4c29534d6725a177a069f02e6035f29$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($c5f6700b36bb7976a2ff96ce4ed4bb$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($b1c736ce89bd99b5ed3e691d69baa12$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($cb458a4f6c581e186f4c36775531c55$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($b4d2b4a9d751516d13e0963808404e$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($bd296420f236ed913ddbbfab9a63cefc$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($d5150585674a5afe719a59ab93$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($b505cb7e3f75774b9c57bd2b92c2186a$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($d47e22347a353aaaffcf$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($fdfdff040cf7a6ae1bcf24d365623726$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($fc44719192dca1041b7fb1ce3088ea1c$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($fdc251bdcb72dd76164ea66f1$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($ebc2a88fe55fcf7339a78a814c6db9c$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($c1d8730967e62b8d6f3035e704d24e$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($eded96a62d721b42449a6beec6af$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($ca104e556a75831cb795a233826f2a0$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($e39eeb8a609d42b7f028409252178c5$exports).default
};
var $e42ce057c820181717dfe5b0c524aea7$$interop$default = $parcel$interopDefault($e42ce057c820181717dfe5b0c524aea7$exports);
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default = $parcel$interopDefault($c9fb1f4220ea2c59cb2e10f0e9828c6e$exports);

function $f01f0d1066865f7027d77d32f5de6fe$var$Picker(props, ref) {
  props = useProviderProps(props);
  props = useFormProps(props);
  let formatMessage = useMessageFormatter($f01f0d1066865f7027d77d32f5de6fe$var$intlMessages);
  let {
    isDisabled,
    direction = 'bottom',
    align = 'start',
    shouldFlip = true,
    placeholder = formatMessage('placeholder'),
    validationState,
    isQuiet,
    label,
    labelPosition = 'top',
    labelAlign,
    isRequired,
    necessityIndicator,
    menuWidth,
    name,
    autoFocus
  } = props;
  let {
    styleProps
  } = useStyleProps(props);
  let state = useSelectState(props);
  let domRef = useDOMRef(ref);
  let popoverRef = useRef();
  let unwrappedPopoverRef = useUnwrapDOMRef(popoverRef);
  let triggerRef = useRef();
  let unwrappedTriggerRef = useUnwrapDOMRef(triggerRef);
  let listboxRef = useRef(); // We create the listbox layout in Picker and pass it to ListBoxBase below
  // so that the layout information can be cached even while the listbox is not mounted.
  // We also use the layout as the keyboard delegate for type to select.

  let layout = useListBoxLayout(state);
  let {
    labelProps,
    triggerProps,
    valueProps,
    menuProps
  } = useSelect(_babelRuntimeHelpersEsmExtends({}, props, {
    keyboardDelegate: layout
  }), state, unwrappedTriggerRef);
  let isMobile = useIsMobileDevice();
  let {
    overlayProps,
    placement,
    updatePosition
  } = useOverlayPosition({
    targetRef: unwrappedTriggerRef,
    overlayRef: unwrappedPopoverRef,
    scrollRef: listboxRef,
    placement: direction + " " + align,
    shouldFlip: shouldFlip,
    isOpen: state.isOpen && !isMobile,
    onClose: state.close
  });
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  }); // Update position once the ListBox has rendered. This ensures that
  // it flips properly when it doesn't fit in the available space.
  // TODO: add ResizeObserver to useOverlayPosition so we don't need this.

  useLayoutEffect(() => {
    if (state.isOpen) {
      requestAnimationFrame(() => {
        updatePosition();
      });
    }
  }, [state.isOpen, updatePosition]);
  let isLoadingInitial = props.isLoading && state.collection.size === 0;
  let isLoadingMore = props.isLoading && state.collection.size > 0; // On small screen devices, the listbox is rendered in a tray, otherwise a popover.

  let listbox = /*#__PURE__*/_react.createElement(FocusScope, {
    restoreFocus: true
  }, /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: () => state.close()
  }), /*#__PURE__*/_react.createElement(ListBoxBase, {
    ref: listboxRef,
    domProps: menuProps,
    disallowEmptySelection: true,
    autoFocus: state.focusStrategy || true,
    shouldSelectOnPressUp: true,
    focusOnPointerEnter: true,
    layout: layout,
    state: state,
    width: isMobile ? '100%' : undefined // Set max height: inherit so Tray scrolling works
    ,
    UNSAFE_style: {
      maxHeight: 'inherit'
    },
    isLoading: isLoadingMore,
    onLoadMore: props.onLoadMore
  }), /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: () => state.close()
  })); // Measure the width of the button to inform the width of the menu (below).


  let [buttonWidth, setButtonWidth] = useState(null);
  let {
    scale
  } = useProvider();
  let onResize = useCallback(() => {
    if (!isMobile) {
      let width = unwrappedTriggerRef.current.offsetWidth;
      setButtonWidth(width);
    }
  }, [unwrappedTriggerRef, setButtonWidth, isMobile]);
  useResizeObserver({
    ref: unwrappedTriggerRef,
    onResize: onResize
  });
  useLayoutEffect(onResize, [scale, state.selectedKey, onResize]);
  let overlay;

  if (isMobile) {
    overlay = /*#__PURE__*/_react.createElement(Tray, {
      isOpen: state.isOpen,
      onClose: state.close,
      shouldCloseOnBlur: true
    }, listbox);
  } else {
    // If quiet, use the default width, otherwise match the width of the button. This can be overridden by the menuWidth prop.
    // Always have a minimum width of the button width. When quiet, there is an extra offset to add.
    // Not using style props for this because they don't support `calc`.
    let width = isQuiet ? null : buttonWidth;

    let style = _babelRuntimeHelpersEsmExtends({}, overlayProps.style, {
      width: menuWidth ? dimensionValue(menuWidth) : width,
      minWidth: isQuiet ? "calc(" + buttonWidth + "px + calc(2 * var(--spectrum-dropdown-quiet-offset)))" : buttonWidth
    });

    overlay = /*#__PURE__*/_react.createElement(Popover, {
      isOpen: state.isOpen,
      UNSAFE_style: style,
      UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown-popover', {
        'spectrum-Dropdown-popover--quiet': isQuiet
      }),
      ref: popoverRef,
      placement: placement,
      hideArrow: true,
      shouldCloseOnBlur: true,
      onClose: state.close
    }, listbox);
  }

  let contents = state.selectedItem ? state.selectedItem.rendered : placeholder;

  if (typeof contents === 'string') {
    contents = /*#__PURE__*/_react.createElement(Text, null, contents);
  }

  let picker = /*#__PURE__*/_react.createElement("div", {
    className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown', {
      'is-invalid': validationState === 'invalid',
      'is-disabled': isDisabled,
      'spectrum-Dropdown--quiet': isQuiet
    })
  }, /*#__PURE__*/_react.createElement(HiddenSelect, {
    isDisabled: isDisabled,
    state: state,
    triggerRef: unwrappedTriggerRef,
    label: label,
    name: name
  }), /*#__PURE__*/_react.createElement(PressResponder, mergeProps(hoverProps, triggerProps), /*#__PURE__*/_react.createElement(FieldButton, {
    ref: triggerRef,
    isActive: state.isOpen,
    isQuiet: isQuiet,
    isDisabled: isDisabled,
    validationState: validationState,
    autoFocus: autoFocus,
    UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown-trigger', {
      'is-hovered': isHovered
    })
  }, /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      icon: {
        UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Icon'),
        size: 'S'
      },
      text: _babelRuntimeHelpersEsmExtends({}, valueProps, {
        UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown-label', {
          'is-placeholder': !state.selectedItem
        })
      }),
      description: {
        isHidden: true
      }
    }
  }, contents), isLoadingInitial && /*#__PURE__*/_react.createElement(ProgressCircle, {
    isIndeterminate: true,
    size: "S",
    "aria-label": formatMessage('loading'),
    UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown-progressCircle')
  }), validationState === 'invalid' && !isLoadingInitial && /*#__PURE__*/_react.createElement(_spectrumIconsUiAlertMedium, {
    UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown-invalidIcon')
  }), /*#__PURE__*/_react.createElement(_spectrumIconsUiChevronDownMedium, {
    UNSAFE_className: classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Dropdown-chevron')
  }))), state.collection.size === 0 ? null : overlay);

  if (label) {
    let labelWrapperClass = classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-Field', {
      'spectrum-Field--positionTop': labelPosition === 'top',
      'spectrum-Field--positionSide': labelPosition === 'side'
    }, classNames($e42ce057c820181717dfe5b0c524aea7$$interop$default, 'spectrum-Field', {
      'spectrum-Dropdown-fieldWrapper--quiet': isQuiet,
      'spectrum-Dropdown-fieldWrapper--positionSide': labelPosition === 'side'
    }), styleProps.className);
    picker = _react.cloneElement(picker, mergeProps(picker.props, {
      className: classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-Field-field')
    }));
    return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, styleProps, {
      ref: domRef,
      className: labelWrapperClass
    }), /*#__PURE__*/_react.createElement(Label, _babelRuntimeHelpersEsmExtends({}, labelProps, {
      labelPosition: labelPosition,
      labelAlign: labelAlign,
      isRequired: isRequired,
      necessityIndicator: necessityIndicator,
      includeNecessityIndicatorInAccessibilityName: true,
      elementType: "span"
    }), label), picker);
  }

  return _react.cloneElement(picker, mergeProps(picker.props, _babelRuntimeHelpersEsmExtends({}, styleProps, {
    ref: domRef
  })));
}
/**
 * Pickers allow users to choose a single option from a collapsible list of options when space is limited.
 */
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref


export const Picker = _react.forwardRef($f01f0d1066865f7027d77d32f5de6fe$var$Picker);
//# sourceMappingURL=module.js.map
